export default {
  styleOverrides: {
    root: {
      '&.MuiInputBase-multiline': {
        padding: 0,
      },
    },
    input: {
      padding: '18.5px 14px',
      lineHeight: '1.1876em',
      height: '1.1876em',
      '.MuiFormControl-marginDense &': {
        padding: '10.5px 14px',
      },
    },
  },
};
